import styled from 'styled-components';
import Screen from 'src/styles/Themes/Screen';

export const SliderWrapper = styled.div`
    ${Screen.desktop} {
        padding: 30px 0 0;
    }
`;
